import React, { memo, useCallback } from "react";

import colors from "app/colors";
import { HelpIcon, ReadOnlyIcon } from "modules/icons";
import CircularIconButton from "modules/_shared/buttons/circular-icon-button";
import {
  MODAL_TYPE,
  useOverlay,
} from "modules/providers/overlay-provider/overlay-provider";

const ReadOnlyHelpButton = () => {
  const { openModal } = useOverlay();

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      e.preventDefault();
      openModal({
        type: MODAL_TYPE.HELP,
        helpModal: {
          icon: <ReadOnlyIcon boxSize={16} fill={colors.blackSecondary} />,
          title: "Read-Only Threads",
          message:
            "When this setting is toggled on, only the user who enabled it will be able to post messages in the thread. Only that user can remove the setting to allow everyone in the thread to post messages.",
        },
      });
    },
    [openModal],
  );

  return (
    <CircularIconButton
      icon={<HelpIcon boxSize={4} fill={colors.gray40} />}
      minW={6}
      h={6}
      aria-label="help info"
      onClick={onClick}
    />
  );
};

export default memo(ReadOnlyHelpButton);
